import { GraphQLClient } from 'graphql-request';
import type { TypedDocumentNode, Variables, GraphQLClientOptions } from './types';

let client: GraphQLClient | null = null;

export const base = <T, V extends Variables>(
  document: TypedDocumentNode<T, V>,
  variables: V,
  options: GraphQLClientOptions
): Promise<T> => {
  if (!client) {
    throw new Error('graphQLClient.init must be called before running any query');
  }

  return client.request<T>({
    ...options,
    document,
    variables,
  });
};

base.init = (endpointUrl: string): void => {
  client = new GraphQLClient(endpointUrl, {
    method: 'POST',
    credentials: 'include',
  });
};
